export const MetricDimensionNames = {
  Pm_LedgerNumericValue: "Pm_LedgerNumericValue",
  Pm_LedgerDateValue: "Pm_LedgerDateValue",
  Pm_LedgerTextValue: "Pm_LedgerTextValue",
};

export const isMetricDimension = (dimension: string) => {
  return Object.values(MetricDimensionNames).includes(dimension);
};
